export default {
    contactus: {
        header:{
            metas:{
                title: "Contact us",
                description:"This is the contact us page for home to live ltd",
                author:"Adebayo Odutola",
                keywords:"home; to, live, ltd, contactus, contact, us ",

            }
        },
        formData: {
            title: "Contact us",
            labels: {
                firstName: "First name",
                surname: "Surname",
                email: "Email",
                telephone: "Telephone",
                subject: "Subject",
                enquiry: "Enquiry",
                capture: "capture",
            },
            placeholders: {
                firstName: "Enter your full name",
                surname: "Enter Surname",
                email: "enter email e.g email@example.com",
                telephone: "Enter your telephone number e.g  0000000000 etc ",
                subject: "Enter short title for your enquiry",
                enquiry: "Please describe your enquiry or comment in details "
            },
            button: {
                text: "Submit",
            }
        }


    },
    homepage: {
        body: {
            hero_images: ["/pub/vu/assets/images/hero4_blur.jpg",
                "/pub/vu/assets/images/hero2.jpg",
                "/pub/vu/assets/images/hero3.jpg",
                "/pub/vu/assets/images/hero5.jpg"],
            alt:["hero property"]
            

        },
    }

};
